import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Drawer, Field, Input, Button } from '@itds/elements/index.js';

import Api from '@carrier/utils/Api';

const Edit = ({ tag, onClose, onSave, show }) => {
  const [data, setData] = useState({});
  const [error, setError] = useState(false);

  useEffect(() => {
    const new_tag = tag || {};

    setData({
      id: new_tag.id,
      name: new_tag.name || ''
    });
  }, [tag]);

  const handleNameChange = e => {
    setData({ ...data, name: e.target.value });
  };

  const handleSave = () => {
    if (data.name) {
      const { id, ...payload } = data;

      setError(false);

      Api.saveFormTag(id, payload).then(() => {
        onSave();
      });
    } else {
      setError(true);
    }
  };

  return (
    <Drawer
      alignRight={true}
      footer={
        <Button onClick={handleSave}>{data.id ? 'Save Changes' : 'Create New Form Tag'}</Button>
      }
      onClose={onClose}
      show={show}
      title={data.id ? 'Editing Form Tag' : 'New Form Tag'}
    >
      <Field label='Name'>
        <Input invalid={error} onChange={handleNameChange} required={true} value={data.name} />
      </Field>
    </Drawer>
  );
};

Edit.propTypes = {
  onClose: PropTypes.func,
  onSave: PropTypes.func,
  show: PropTypes.bool,
  tag: PropTypes.object
};

export default Edit;
